var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmacies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:none;stroke:#b53729;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.66,98H95a5.48,5.48,0,0,1,5.48,5.48v.92A5.48,5.48,0,0,1,95,109.86h-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.75,98H74.17a5.48,5.48,0,0,1-5.48-5.49v-.91a5.48,5.48,0,0,1,5.48-5.48h6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.75,74.2H69.94A15.71,15.71,0,0,1,54.22,58.49V55.87A15.72,15.72,0,0,1,69.94,40.15h1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.48,40.16h-.14a15.67,15.67,0,0,1,12.77,6.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.53,
    y1: 129.97,
    x2: 85.53,
    y2: 66.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.88,58.31a8.47,8.47,0,0,0,8.29,8.33H99.9a8.45,8.45,0,0,0,8.28-8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.75,121.76h-2.4a5.48,5.48,0,0,1-5.48-5.48v-.91a5.48,5.48,0,0,1,5.48-5.49h6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.66,74.14H105a5.51,5.51,0,0,1,5.5,5.51v.92a5.5,5.5,0,0,1-5.5,5.5H78.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.49,50a3.67,3.67,0,1,1-3.67-3.66A3.67,3.67,0,0,1,89.49,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.7,135.34h29.66a13.46,13.46,0,0,0-11-5.73H81.75A13.49,13.49,0,0,0,70.7,135.34Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacies);
export default __webpack_public_path__ + "static/media/pharmacies.39d7a627b40a731112c55d8ce7d5314a.svg";
export { ForwardRef as ReactComponent };